/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect Ratio Calculator`)
};

const es_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Relación de Aspecto`)
};

const de_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenverhältnis-Rechner`)
};

const nl_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beeldverhouding Calculator`)
};

const fr_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de rapport d'aspect`)
};

const it_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore rapporto di aspetto`)
};

const pt_br2_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Taxa de Aspecto`)
};

const pt_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Proporção de Aspecto`)
};

const ja_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アスペクト比計算機`)
};

const zh_ar_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宽高比计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_tool_name", locale)
	if (locale === "en") return en_ar_tool_name(inputs)
	if (locale === "es") return es_ar_tool_name(inputs)
	if (locale === "de") return de_ar_tool_name(inputs)
	if (locale === "nl") return nl_ar_tool_name(inputs)
	if (locale === "fr") return fr_ar_tool_name(inputs)
	if (locale === "it") return it_ar_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_ar_tool_name(inputs)
	if (locale === "pt") return pt_ar_tool_name(inputs)
	if (locale === "ja") return ja_ar_tool_name(inputs)
	return zh_ar_tool_name(inputs)
};